// src/services/api-config.js

// ✅ Base API URL - غيّره حسب السيرفر بتاعك
export const API_BASE_URL = 'https://new.sbdemolition.online/api';

// Alternative for local development:
// export const API_BASE_URL = 'http://localhost/api';

// ✅ Helper function for API calls with error handling
export const apiCall = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      ...options,
      credentials: 'include', // Always include cookies
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API Call Error:', error);
    throw error;
  }
};

export default API_BASE_URL;
